import CitySEOHead from "@/components/feature/CitySEOHead";
import ALHeroSection from "./components/HeroSection";
import ALCitiesDirectory from "./components/CitiesDirectory";
import ALStateResources from "./components/StateResources";
import ALFAQSection, { faqs } from "./components/FAQSection";
import ALFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const alabamaFaqs = faqs.map((f: { question: string; answer: string }) => ({ q: f.question, a: f.answer }));

const alabamaServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens." },
  { name: "New Passport", description: "First-time passport application assistance." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service." },
  { name: "Child Passport", description: "Passport services for minors under 16." },
  { name: "Name Change", description: "Passport correction and name change service." },
  { name: "Second Passport & Damaged", description: "Second passport issuance and damaged passport replacement." },
];

export default function AlabamaPage() {
  return (
    <>
      <CitySEOHead
        city="Alabama"
        state="Alabama"
        stateAbbr="AL"
        route="/states/alabama"
        title="Alabama Passport Services — Expedited & Emergency | Fast Passport Center"
        description="Expedited passport services across Alabama — Birmingham, Huntsville, Mobile, Montgomery, Tuscaloosa. Emergency processing as fast as 24 hours. A+ BBB rated courier service."
        geoPlacename="Alabama, United States"
        geoPosition="32.3617;-86.2792"
        faqs={alabamaFaqs}
        servicesSchema={alabamaServices}
      />
      <div className="font-sans">
        <ALHeroSection />
        <ALCitiesDirectory />
        <ALStateResources />
        <ALFAQSection />
        <SEOCrossLinks state="AL" />
        <ALFinalCTA />
      </div>
    </>
  );
}